module.exports = __webpack_public_path__ + "static/img/brees-2003-slide-2.1a55998.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-slide-2.jpg
// module id = Lq3D
// module chunks = 1